
import { Component, Vue } from 'vue-property-decorator';

import { sharedState } from '../../../../../framework/state';
import TextField from '../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../framework/fields/SelectField.vue';
import SwitchField from '../../../../../framework/fields/SwitchField.vue';
import { getCustomerOptions } from '../../../../service/application_options_service';
import NumberField from '../../../../../framework/fields/NumberField.vue';
import DateField from '../../../../../framework/fields/DateField.vue';
import { AddMonthlySalesInvoiceReq } from '../../../../../../common/application/model/api/AddMonthlySalesInvoiceReq';
import { postMonthlySalesInvoiceRequest } from '../../../../client/sales_invoice_client';
import { ValidationObserver } from 'vee-validate';

@Component({
    components: { DateField, NumberField, SwitchField, SelectField, TextField, ValidationObserver },
})
export default class AddMonthlySalesInvoice extends Vue {
    // State
    shared = sharedState;
    local = {
        row: {} as AddMonthlySalesInvoiceReq,
        customerOptions: [] as { id: string | undefined; label: string }[],
    };

    // Functions
    async mounted() {
        this.local.customerOptions = await getCustomerOptions();
    }

    async add() {
        const resp = await postMonthlySalesInvoiceRequest(this.local.row);
        this.back();
    }

    back() {
        this.$router.go(-1);
    }
}
